// extracted by mini-css-extract-plugin
export default {"assignee__modal":"AddAssigneeModal_assignee__modal__6GmZ3","icon__cont":"AddAssigneeModal_icon__cont__OeJK7"};